'use strict';

var importModalConfig = require('../config/importModalConfigs.json');
var _ = require('lodash');
var ImportCsvModalController = function ImportCsvModalController($scope, $rootScope, $q, importCsvUploadingService, $sce, featureToggleService) {
  var LOADING = 'loading';
  var VALID_CLASS = 'valid';
  var INVALID_CLASS = 'invalid';
  var MAX_FILE_SIZE_IN_BYTES = 1024 * 1024 * 10;
  var MAX_DISPLAY_ERRORS_SIZE = 12;
  var DOT = '.';
  var stateToBeRestored = {
    chosenFile: null,
    chosenFileName: ''
  };
  resetModel();
  function resetModel() {
    $scope.chosenFileName = '';
    $scope.chosenFile = null;
    $scope.importedRowsStatus = '';
    $scope.importStatus = '';
    $scope.isImportFailed = false;
    $scope.isUploadInProgress = false;
    $scope.isImportValidationError = false;
    $scope.shouldDisplayErrorsDownloadLink = $scope.shouldDisplayErrorsDownloadLink || featureToggleService.isEnabled('FARES_OPTIMIZER');
    $scope.isOnlyFO = featureToggleService.isEnabled('FARES_OPTIMIZER') && featureToggleService.isDisabled('REVENUE_OPTIMIZER') && featureToggleService.isDisabled('DYNAMIC_AVAILABILITY');
    $scope.errorMessages = [];
  }
  function isImportValid(invalidRowsNumber) {
    return invalidRowsNumber === 0;
  }
  function saveCurrentState() {
    stateToBeRestored.chosenFile = $scope.chosenFile;
    stateToBeRestored.chosenFileName = $scope.chosenFileName;
  }
  function restorePreviousModalState() {
    $scope.chosenFile = stateToBeRestored.chosenFile;
    $scope.chosenFileName = stateToBeRestored.chosenFileName;
  }
  function createMessageFromTemplate(template, filler) {
    var multiInputTemplate = _.template(template);
    return multiInputTemplate(filler);
  }
  function getImportMessage(uploadResponse) {
    if (!_.isNil($scope.errorsCases) && uploadResponse.invalidRowsCount > 0) {
      if (importCsvUploadingService.hasMultipleErrorsForSeveralEntities(uploadResponse.errorMessages)) {
        return createMessageFromTemplate($scope.errorsCases.entitiesKeys, {
          'allCount': uploadResponse.allRowsCount,
          'errorCount': uploadResponse.invalidRowsCount
        });
      } else if (importCsvUploadingService.hasMultipleErrorsPerFileLines(uploadResponse.errorMessages, uploadResponse.invalidRowsCount)) {
        return createMessageFromTemplate($scope.errorsCases.lineErrors, {
          'errorCount': uploadResponse.invalidRowsCount
        });
      } else if (importCsvUploadingService.hasFileLevelError(uploadResponse.errorMessages, uploadResponse.invalidRowsCount)) {
        return _.values(uploadResponse.errorMessages)[0];
      }
      return '';
    } else if (uploadResponse.invalidRowsCount && $scope.isOnlyFO) {
      return 'Please fix the errors and upload the file again.';
    } else if (uploadResponse.invalidRowsCount) {
      var successfulImports = uploadResponse.allRowsCount - uploadResponse.invalidRowsCount;
      return successfulImports + ' from ' + uploadResponse.allRowsCount + ' records were imported. ' + uploadResponse.invalidRowsCount + ' errors occurred';
    } else {
      return uploadResponse.allRowsCount + ' records were imported successfully';
    }
  }
  function setUpImportNotification(uploadResponse) {
    if (uploadResponse.persistedRowsCount === 0) {
      $scope.isImportFailed = true;
    }
    if (isImportValid(uploadResponse.invalidRowsCount)) {
      $scope.importStatus = VALID_CLASS;
    } else {
      $scope.isImportValidationError = true;
      $scope.importStatus = INVALID_CLASS;
      $scope.errorMessages = uploadResponse.errorMessages;
      $scope.shouldDisplayErrorsList = $scope.shouldDisplayErrorsDownloadLink && !$scope.hideErrorsList && uploadResponse.invalidRowsCount <= MAX_DISPLAY_ERRORS_SIZE;
      if ($scope.isErrorGridEnabled()) {
        $scope.errorGridState.data = importCsvUploadingService.setUpImportErrorLogData(uploadResponse.rows);
      }
    }
    $scope.importedRowsStatus = '' + getImportMessage(uploadResponse);
    $scope.isUploadInProgress = false;
    saveCurrentState();
  }
  function handleServerImportError(uploadResponse) {
    $scope.isImportValidationError = true;
    $scope.importStatus = INVALID_CLASS;
    $scope.importedRowsStatus = 'Please make sure that the file structure matches the fields in the grid you are importing data to.';
    $scope.importErrorReason = $scope.showDetailedErrorMessage ? uploadResponse.data.message : '';
    $scope.isUploadInProgress = false;
    $scope.isImportFailed = true;
  }
  $scope.setScopeAtUploadStart = function () {
    $scope.importedRowsStatus = '';
    $scope.importStatus = LOADING;
    $scope.isImportValidationError = false;
    $scope.isUploadInProgress = true;
    $scope.isImportFailed = false;
    $scope.errorMessages = [];
  };
  $scope.processFileUpload = function () {
    if (_.isFunction($scope.localImportHandler)) {
      return $scope.localImportHandler($scope.chosenFile);
    } else {
      return importCsvUploadingService.sendFile($scope.chosenFile, $scope.gridId, $scope.selectedComplexHepType, $scope.domainName, $scope.scenarioName, $scope.calibrationName);
    }
  };
  $scope.uploadFile = function () {
    $scope.setScopeAtUploadStart();
    $scope.processFileUpload().then(setUpImportNotification, handleServerImportError);
  };
  function reloadGridDataIfImportSuccessful() {
    if (!$scope.isImportFailed) {
      $rootScope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
    }
  }
  $scope.handleModalHide = function () {
    reloadGridDataIfImportSuccessful();
  };
  $scope.initConfig = function (gridId, mode, scenarioName, calibrationName) {
    resetModel();
    if (gridId) {
      var config = getImportModalConfig(gridId, mode);
      $scope.gridId = gridId;
      $scope.domainName = config.domainName;
      $scope.userWarningHeading = $sce.trustAsHtml(config.warning.heading);
      $scope.userWarningBody = $sce.trustAsHtml(config.warning.body);
      $scope.userMessageHeading = $sce.trustAsHtml(config.message.heading);
      $scope.userMessageBody = $sce.trustAsHtml(config.message.body);
      $scope.additionalMessage = $sce.trustAsHtml(config.additionalMessage);
      $scope.acceptedType = getFileAcceptedType(config.acceptedType);
      $scope.placeholder = getFileInputPlaceholder(config.placeholder);
      $scope.selectedComplexHepType = config.hepType || $scope.selectedComplexHepType;
      $scope.shouldDisplayErrorsDownloadLink = $scope.shouldDisplayErrorsDownloadLink || !!config.shouldDisplayErrorsDownloadLink;
      $scope.hideErrorsList = config.hideErrorsList;
      $scope.errorsCases = config.errorsCases;
      $scope.scenarioName = scenarioName;
      $scope.calibrationName = calibrationName;
    }
  };
  function getImportModalConfig(gridId, mode) {
    var config = importModalConfig[gridId + '-' + mode] || importModalConfig[gridId] || importModalConfig["default"];
    if ($scope.$parent && $scope.$parent.data) {
      var selectedHep = _.filter($scope.$parent.data, function (data) {
        return data.isExpanded || data.isSubModalMessage;
      });
      var selectedHierarchy = _.filter(selectedHep[0].hierarchies, function (hierarchy) {
        return hierarchy.isSelected;
      });
      $scope.selectedComplexHepType = selectedHep[0].type;
      config = importModalConfig[_.join([gridId, selectedHep[0].type], DOT)] ? importModalConfig[_.join([gridId, selectedHep[0].type], DOT)] : config;
      config = selectedHierarchy.length > 0 && importModalConfig[_.join([gridId, selectedHep[0].type, selectedHierarchy[0].key], DOT)] ? importModalConfig[_.join([gridId, selectedHep[0].type, selectedHierarchy[0].key], DOT)] : config;
    }
    return config;
  }
  function getFileAcceptedType(acceptedType) {
    return acceptedType ? acceptedType : '.csv, text/csv';
  }
  function getFileInputPlaceholder(placeholder) {
    return placeholder ? placeholder : 'Select CSV file to upload';
  }
  $scope.handleModalHideAndResetItsState = function () {
    reloadGridDataIfImportSuccessful();
    restorePreviousModalState();
  };
  $scope.isErrorGridEnabled = function () {
    return !!$scope.errorGridState;
  };
  $scope.showErrorLog = function ($event) {
    if ($scope.isErrorGridEnabled()) {
      $event.preventDefault();
      $scope.errorGridState.show = true;
    }
  };
  $scope.isUploadButtonDisabled = function () {
    return !$scope.chosenFileName || $scope.isUploadInProgress || $scope.chosenFile.size > MAX_FILE_SIZE_IN_BYTES;
  };
  $scope.hideErrorLog = function () {
    if ($scope.isErrorGridEnabled()) {
      $scope.errorGridState.show = false;
      $scope.showImportModal();
    }
  };
};
ImportCsvModalController.$inject = ['$scope', '$rootScope', '$q', 'ImportCsvUploadingService', '$sce', 'FeatureToggleService'];
module.exports = ImportCsvModalController;